import React, { useState, useEffect, useReducer } from 'react'
import {
  Button,
  ButtonGroup,
  ButtonToolbar,
  Checkbox,
  Col,
  ControlLabel,
  Grid,
  Icon,
  IconButton,
  Input,
  Modal,
  Panel,
  Row,
  Table,
} from 'rsuite'
import { budgetFormat } from '../../utils/formatterUtil'
import SaveButton from '../../components/buttons/saveButton/SaveButton'
import { Controller, useForm } from 'react-hook-form'
import DatePickerCustom from '../../components/datePicker/DatePickerCustom'
import { getMaxLengthData, isValidators, requiredFiled } from '../../utils/ValidatorUtils'
import ErrorMessage from '../../components/message/errorMessage/ErrorMessage'
import { DATE_FORMAT } from '../../constants/date'
import moment from 'moment'
import CancelButton from '../../components/buttons/cancelButton/CancelButton'
import notification from '../../utils/notification'
import { maskIdCard } from '../../utils/dataUtil'
import TooltipButton from '../../components/buttons/TooltipButton'
import { doneLoading, startLoading } from '../../utils/loading'
import { downloadFile } from '../../utils/fileUtil'
import { exportAnnualTaxRemittanceText } from '../../redux/actions/eFilling'

export default function PaymentList({
  schema: _schema,
  schemaPersons,
  handleOnSubmit,
  requestExport,
  onExport = () => {},
  ...props
}) {
  const { register, handleSubmit, errors, control, getValues, setValue, clearErrors } = useForm()
  const { Column, HeaderCell, Cell } = Table
  const [formSchema, setFormSchema] = useState(_schema)
  const [isShowConfirm, setIsShowConfirm] = useState(false)
  const [isLoading, setIsLoading] = useState(false)
  const [checkedKeys, setCheckedKeys] = useState([])
  const [countSelected, setCountSelected] = useState(0)
  const [indeterminate, setIndeterminate] = useState(false)
  const [tableData, setTableData] = useState([])
  const [buttonType, setButtonType] = useState(true)
  const [filteredItemsList, setFilteredItemsList] = useState([])
  const [filteredItemsStausModel, setFilteredItemsStausModel] = useState(false)
  // const [checkedIdKeys, setCheckedIdKeys] = useState([])

  useEffect(() => {
    if (_schema) {
      setTableData(_schema.values || [])
      setFormSchema(_schema)
    }
  }, [_schema])

  const onSubmit = (data) => {
    // var checkedIdKeys = []
    // if (checkedKeys?.length > 0) {
    //   const ids = formSchema.values
    //     .filter((item) => checkedKeys.includes(item.controlSequenceNo))
    //     .map((item) => item.id)

    //   checkedIdKeys = ids
    // }

    // console.log('checkedIdKeys => ', checkedIdKeys)

    // return false

    const request = {
      ids: checkedKeys,
      // ids: checkedIdKeys,
      buttonType: buttonType,
    }

    if (buttonType == true) {
      request.dateReceipt = data?.dateReceipt ? moment(data.dateReceipt).format(DATE_FORMAT) : ''
      request.dateSubmission = data?.dateSubmission
        ? moment(data.dateSubmission).format(DATE_FORMAT)
        : ''
      request.receiptNumber = data?.receiptNumber || ''
      request.referenceNumber = data?.referenceNumber || ''
    }

    setIsShowConfirm(false)
    handleOnSubmit(request)
  }

  const handleModalSubmit = (data) => {
    console.log('data => ', data)
    onSubmit(data)
  }

  const handleCheckAll = (value, checked) => {
    let newArr = []
    var checkedKeys = checked ? formSchema.headerValues.map((item) => item.controlSequenceNo) : []

    formSchema.headerValues.map((item) => {
      if (!item.isTotal) {
        newArr.push(item.controlSequenceNo)
      }
    })

    checkedKeys = checkedKeys.filter((item) => item != null)

    setCheckedKeys(checkedKeys)
    // setCheckedIdKeys(checkedIdKeys)
    setCountSelected(newArr.length)
  }

  const handleCheck = (value, checked) => {
    const nextCheckedKeys = checked
      ? [...checkedKeys, value]
      : checkedKeys.filter((item) => item !== value)

    setCheckedKeys(nextCheckedKeys)
    setCountSelected(nextCheckedKeys.length)
  }

  const CheckCell = ({ rowData, onChange, checkedKeys, dataKey, ...props }) => {
    if (rowData.isTotal) {
      return <Cell {...props} style={{ padding: 0 }}></Cell>
    }

    return (
      <Cell {...props} style={{ padding: 0 }}>
        <div style={{ lineHeight: '46px' }}>
          <Checkbox
            value={rowData[dataKey]}
            inline
            onChange={onChange}
            checked={checkedKeys.some((item) => item === rowData[dataKey])}
            style={{ marginLeft: -30 }}
          />
          {props.rowIndex + 1}
        </div>
      </Cell>
    )
  }

  const handleOnExport = () => {
    onExport(requestExport)
  }

  const handlePreviewDetail = (rowData) => {
    console.log('handlePreviewDetail => ', schemaPersons)
    console.log('handlePreviewDetail2 => ', formSchema?.values)

    const formSchemaValues = schemaPersons // formSchema?.values

    const hasItems = Array.isArray(formSchemaValues) && formSchemaValues?.length > 0

    if (hasItems) {
      const controlSequenceNo = rowData.controlSequenceNo

      const filteredItems = Array.isArray(formSchemaValues)
        ? formSchemaValues.filter(
            (item) =>
              item.controlSequenceNo !== null &&
              item.controlSequenceNo === controlSequenceNo &&
              !item.isTotal
          )
        : []

      if (filteredItems.length <= 0) {
        notification.open('error', {
          title: 'ไม่สามารถทำรายการได้ กรุณาลองใหม่หรือติดต่อผู้ดูแลระบบ',
          duration: 5000,
        })

        return false
      }

      const totalSummary = filteredItems.reduce(
        (acc, item) => {
          acc.payAmount += Number(item.payAmount || 0)
          acc.taxAmount += Number(item.taxAmount || 0)
          // acc.yearTaxPayAmount += Number(item.yearTaxPayAmount || 0)
          // acc.yearTaxSubmitAmount += Number(item.yearTaxSubmitAmount || 0)

          return acc
        },
        {
          controlSequenceNo: null,
          withholdingYear: null,
          submitStatus: null,
          taxId: null,
          fullName: null,
          address: null,

          payAmount: 0,
          taxAmount: 0,
          yearTaxPayAmount: 0,
          yearTaxSubmitAmount: 0,

          isTotal: true,
        }
      )

      // const totalSummary = filteredItems.reduce(
      //   (acc, item) => {
      //     acc.amountPaid += Number(item.amountPaid || 0)
      //     acc.amountPaidSubmission += Number(item.amountPaidSubmission || 0)
      //     acc.amountTax += Number(item.amountTax || 0)
      //     acc.amountTaxSubmission += Number(item.amountTaxSubmission || 0)

      //     return acc
      //   },
      //   {
      //     controlSequenceNo: null,
      //     id: null,
      //     withholdingYear: null,
      //     withholdingMonth: null,
      //     withholdingMonthLabel: null,
      //     datePayment: null,
      //     projectCode: null,
      //     contractNo: null,
      //     withholdingType: null,
      //     submitStatus: null,
      //     dataSource: null,
      //     runingSequenceNo: null,
      //     taxId: null,
      //     fullName: null,
      //     address: null,
      //     branch: null,
      //     amountPaid: 0,
      //     amountTax: 0,
      //     withholdingConditions: null,
      //     datePaymentSubmission: null,
      //     amountPaidSubmission: 0,
      //     amountTaxSubmission: 0,
      //     filingType: null,
      //     datePaymentTax: null,
      //     referenceNumber: null,
      //     receiptNumberSubmission: null,
      //     incomeAccording: null,
      //     typeSubmitted: null,
      //     dateSubmission: null,
      //     receiptNumber: null,
      //     dateReceipt: null,
      //     isTotal: true,
      //   }
      // )

      filteredItems.push(totalSummary)

      setFilteredItemsList(filteredItems)

      setFilteredItemsStausModel(true)
    }
  }

  const onDownloadTextFile = async (rowData) => {
    setIsLoading(true)
    startLoading()
    try {
      const request = requestExport
      request.controlSequenceNo = rowData?.controlSequenceNo || ''

      let fileName = ''
      if (request.withholdingTypeValue === 1 || request.withholdingTypeValue === 4) {
        fileName = 'ภงด_1.txt'
      } else if (request.withholdingTypeValue === 2 || request.withholdingTypeValue === 5) {
        fileName = 'ภงด_3.txt'
      } else {
        notification.open('error', {
          title: 'ไม่สามารถทำรายการได้ กรุณาลองใหม่หรือติดต่อผู้ดูแลระบบ',
          duration: 5000,
        })

        return false
      }

      const file = await exportAnnualTaxRemittanceText(request)

      if (file) {
        downloadFile(file, fileName)
      } else {
        notification.open('error', {
          title: 'ไม่สามารถทำรายการได้ กรุณาลองใหม่หรือติดต่อผู้ดูแลระบบ',
          duration: 5000,
        })
      }
    } catch (e) {
      console.log('handleExportFile error : ', e)
      notification.open('error', {
        title: e?.errors?.message || 'ไม่สามารถทำรายการได้ กรุณาลองใหม่หรือติดต่อผู้ดูแลระบบ',
        duration: 5000,
      })
    }
    setIsLoading(false)
    doneLoading()
  }

  return (
    <>
      <Row style={{ textAlign: 'end', marginTop: 10 }}>
        <ButtonToolbar>
          <SaveButton
            disabled={isLoading}
            onClick={(e) => {
              if (checkedKeys.length > 0) {
                setIsShowConfirm(true)
                setButtonType(true)
              } else {
                notification.open('error', {
                  title: 'กรุณาเลือกรายการ',
                  duration: 5000,
                })
              }
            }}
          >
            {formSchema?.buttonTxt?.deliveryList}
          </SaveButton>
          <CancelButton
            onClick={(e) => {
              if (checkedKeys.length > 0) {
                setIsShowConfirm(true)
                setButtonType(false)
              } else {
                notification.open('error', {
                  title: 'กรุณาเลือกรายการ',
                  duration: 5000,
                })
              }
            }}
          >
            ยกเลิกรายการ
          </CancelButton>
          <SaveButton disabled={isLoading} icon="file-pdf-o" onClick={handleOnExport}>
            {formSchema?.buttonTxt?.deliveryListExport}
          </SaveButton>
          {/* <IconButton
            appearance="ghost"
            icon={<Icon icon="file-pdf-o" className="bt-gost-icon-radius" />}
            onClick={handleOnExport}
          >
            {formSchema?.buttonTxt?.deliveryListExport}
          </IconButton> */}
        </ButtonToolbar>
      </Row>

      <Table
        wordWrap
        autoHeight
        data={formSchema?.headerValues || []}
        style={{ marginTop: 10 }}
        headerHeight={70}
      >
        <Column width={95} align="center">
          <HeaderCell style={{ padding: 0 }}>
            <div style={{ lineHeight: '40px' }}>
              <Controller
                name="chkRow"
                control={control}
                render={(props) => {
                  return (
                    <Checkbox
                      inline
                      checked={props.value}
                      indeterminate={indeterminate}
                      onChange={(e, checked) => {
                        props.onChange(checked)
                        handleCheckAll(null, checked)
                      }}
                      style={{ marginLeft: -10 }}
                    >
                      <b>ลำดับ</b>
                    </Checkbox>
                  )
                }}
              />
            </div>
          </HeaderCell>

          <CheckCell
            dataKey="controlSequenceNo"
            checkedKeys={checkedKeys}
            onChange={(value, checked) => {
              // console.log('one checked => ', value, checked)
              handleCheck(value, checked)
            }}
          />
        </Column>

        <Column width={120} resizable align="center">
          <HeaderCell>ลำดับการยื่นแบบ</HeaderCell>
          <Cell dataKey="sequenceNo" />
        </Column>

        <Column width={170} resizable>
          <HeaderCell>ปี พ.ศ.(ปีภาษีที่หัก)</HeaderCell>
          <Cell dataKey="withholdingYear" />
        </Column>

        <Column width={180} resizable>
          <HeaderCell>สถานะยื่นแบบ</HeaderCell>
          <Cell dataKey="submitStatusLabel" />
        </Column>

        <Column width={170} resizable>
          <HeaderCell>จำนวนเงินที่จ่าย</HeaderCell>
          <Cell style={{ textAlign: 'right' }}>
            {(rowData) => {
              if (rowData.isTotal) {
                return <b>{budgetFormat(rowData.payAmount || 0)}</b>
              }
              return budgetFormat(rowData.payAmount || 0)
            }}
          </Cell>
        </Column>

        <Column width={170} resizable>
          <HeaderCell>จำนวนเงินภาษีที่หัก</HeaderCell>
          <Cell style={{ textAlign: 'right' }}>
            {(rowData) => {
              if (rowData.isTotal) {
                return <b>{budgetFormat(rowData.taxAmount || 0)}</b>
              }
              return budgetFormat(rowData.taxAmount || 0)
            }}
          </Cell>
        </Column>

        <Column width={180} resizable>
          <HeaderCell>จำนวนเงินที่จ่ายทั้งปี</HeaderCell>
          <Cell style={{ textAlign: 'right' }}>
            {(rowData) => {
              if (rowData.isTotal) {
                return <b>{budgetFormat(rowData.yearTaxPayAmount || 0)}</b>
              }
              return budgetFormat(rowData.yearTaxPayAmount || 0)
            }}
          </Cell>
        </Column>

        <Column width={200} resizable>
          <HeaderCell>จำนวนเงินภาษีที่หักและนำส่งทั้งปี</HeaderCell>
          <Cell style={{ textAlign: 'right' }}>
            {(rowData) => {
              if (rowData.isTotal) {
                return <b>{budgetFormat(rowData.yearTaxSubmitAmount || 0)}</b>
              }
              return budgetFormat(rowData.yearTaxSubmitAmount || 0)
            }}
          </Cell>
        </Column>

        <Column width={170} resizable align="left">
          <HeaderCell>วันเดือนปีที่ชำระเงิน</HeaderCell>
          <Cell dataKey="yearTaxBillingDateLabel" />
        </Column>

        <Column width={160} resizable align="left">
          <HeaderCell>หมายเลขที่อ้างอิงในการยื่นแบบ</HeaderCell>
          <Cell dataKey="yearTaxBillingRefNo" />
        </Column>

        <Column width={150} resizable align="left">
          <HeaderCell>เลขที่ใบเสร็จรับเงิน</HeaderCell>
          <Cell dataKey="yearTaxBillingNo" />
        </Column>

        <Column width={150} resizable align="left">
          <HeaderCell>วันเดือนปีที่นำส่ง</HeaderCell>
          <Cell dataKey="yearTaxSubmitDateLabel" />
        </Column>

        <Column width={120} align={'center'} fixed="right">
          <HeaderCell></HeaderCell>
          <Cell>
            {(rowData) => {
              return (
                <>
                  <ButtonGroup>
                    <TooltipButton
                      isStart={true}
                      icon="eye"
                      tooltip={`แสดง`}
                      onClick={() => {
                        handlePreviewDetail(rowData)
                      }}
                    />
                    <TooltipButton
                      isStart={false}
                      icon="download"
                      tooltip={`ดาวน์โหลด`}
                      onClick={() => {
                        onDownloadTextFile(rowData)
                      }}
                    />
                  </ButtonGroup>
                </>
              )
            }}
          </Cell>
        </Column>
      </Table>

      <Modal
        show={isShowConfirm}
        size="sm"
        onHide={(e) => {
          setIsShowConfirm(false)
        }}
      >
        <Modal.Header>
          <Modal.Title></Modal.Title>
        </Modal.Header>
        {buttonType == true ? (
          <>
            <Modal.Body>
              <div style={{ padding: 5 }}>
                <Row style={{ marginLeft: 10, marginBottom: 10 }}>
                  <Col lg={7} md={7} sm={24} xs={24} style={{ textAlign: 'right' }}>
                    <ControlLabel>
                      {requiredFiled(
                        formSchema.dateSubmission.validators,
                        formSchema.dateSubmission.label
                      )}
                    </ControlLabel>
                  </Col>
                  <Col lg={10} md={10} sm={24} xs={24}>
                    <ErrorMessage error={errors[formSchema.dateSubmission.name]} />
                    <Controller
                      key={formSchema.dateSubmission.name}
                      name={formSchema.dateSubmission.name}
                      control={control}
                      defaultValue={
                        formSchema.dateSubmission.value
                          ? moment(formSchema.dateSubmission.value, DATE_FORMAT).toDate()
                          : moment().startOf('day').toDate()
                      }
                      rules={isValidators(formSchema.dateSubmission.validators)}
                      render={(props) => {
                        return (
                          <DatePickerCustom
                            {...props}
                            // disabled={formSchema.isReceiveAnnuity}

                            // startDate={sessionGetItemStr('projectStartDate')}
                            // endDate={sessionGetItemStr('projectEndDate')}
                          />
                        )
                      }}
                    />
                  </Col>
                </Row>
                <Row style={{ marginLeft: 10, marginBottom: 10 }}>
                  <Col lg={7} md={7} sm={24} xs={24} style={{ textAlign: 'right' }}>
                    <ControlLabel>
                      {requiredFiled(
                        formSchema.receiptNumber.validators,
                        formSchema.receiptNumber.label
                      )}
                    </ControlLabel>
                  </Col>
                  <Col lg={10} md={10} sm={24} xs={24}>
                    <ErrorMessage error={errors[formSchema.receiptNumber.name]} />
                    <Controller
                      name={formSchema.receiptNumber.name}
                      control={control}
                      defaultValue={formSchema.receiptNumber.value || ''}
                      rules={isValidators(formSchema.receiptNumber.validators)}
                      render={(props) => {
                        return (
                          <Input
                            placeholder={'ระบุ' + formSchema.receiptNumber.label}
                            value={props.value}
                            maxLength={getMaxLengthData(formSchema.receiptNumber.validators).value}
                            onChange={(value, e) => {
                              props.onChange(value)
                            }}
                            // disabled={formSchema.receiptNumber.disabled}
                          />
                        )
                      }}
                    />
                  </Col>
                </Row>
                <Row style={{ marginLeft: 10, marginBottom: 10 }}>
                  <Col lg={7} md={7} sm={24} xs={24} style={{ textAlign: 'right' }}>
                    <ControlLabel>{formSchema.referenceNumber.label}</ControlLabel>
                  </Col>
                  <Col lg={10} md={10} sm={24} xs={24}>
                    <ErrorMessage error={errors[formSchema.referenceNumber.name]} />
                    <Controller
                      name={formSchema.referenceNumber.name}
                      control={control}
                      defaultValue={formSchema.referenceNumber.value || ''}
                      rules={isValidators(formSchema.referenceNumber.validators)}
                      render={(props) => {
                        return (
                          <Input
                            placeholder={'ระบุ' + formSchema.referenceNumber.label}
                            value={props.value}
                            maxLength={
                              getMaxLengthData(formSchema.referenceNumber.validators).value
                            }
                            onChange={(value, e) => {
                              props.onChange(value)
                            }}
                            // disabled={formSchema.referenceNumber.disabled}
                          />
                        )
                      }}
                    />
                  </Col>
                </Row>
                <Row style={{ marginLeft: 10 }}>
                  <Col lg={7} md={7} sm={24} xs={24} style={{ textAlign: 'right' }}>
                    <ControlLabel>
                      {requiredFiled(
                        formSchema.dateReceipt.validators,
                        formSchema.dateReceipt.label
                      )}
                    </ControlLabel>
                  </Col>
                  <Col lg={10} md={10} sm={24} xs={24}>
                    <ErrorMessage error={errors[formSchema.dateReceipt.name]} />
                    <Controller
                      key={formSchema.dateReceipt.name}
                      name={formSchema.dateReceipt.name}
                      control={control}
                      defaultValue={
                        formSchema.dateReceipt.value
                          ? moment(formSchema.dateReceipt.value, DATE_FORMAT).toDate()
                          : moment().startOf('day').toDate()
                      }
                      rules={isValidators(formSchema.dateReceipt.validators)}
                      render={(props) => {
                        return (
                          <DatePickerCustom
                            {...props}
                            // disabled={formSchema.isReceiveAnnuity}

                            // startDate={sessionGetItemStr('projectStartDate')}
                            // endDate={sessionGetItemStr('projectEndDate')}
                          />
                        )
                      }}
                    />
                  </Col>
                </Row>
              </div>
            </Modal.Body>
          </>
        ) : (
          <>
            <Modal.Body>
              <span>ยืนยันยกเลิกรายนำส่ง</span>
            </Modal.Body>
          </>
        )}

        <Modal.Footer>
          <Button
            // onClick={(e) => {
            //   onSubmit()
            // }}
            onClick={handleSubmit(handleModalSubmit)}
            appearance="primary"
          >
            บันทึก
          </Button>
          <Button
            onClick={(e) => {
              setIsShowConfirm(false)
            }}
            color="blue"
            appearance="primary"
          >
            ยกเลิก
          </Button>
        </Modal.Footer>
      </Modal>

      <Modal
        full
        show={filteredItemsStausModel}
        // overflow={true}
        onHide={() => {
          setFilteredItemsStausModel(false)
        }}
      >
        <Modal.Header>
          <Modal.Title></Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div style={{ minHeight: 500 }}>
            <Table
              wordWrap
              height={400}
              // minHeight={400}
              // autoHeight
              data={filteredItemsList || []}
              style={{ marginTop: 10 }}
              headerHeight={70}
              // width={5050}
              // shouldUpdateScroll={false}
            >
              <Column width={70} align="center">
                <HeaderCell>ลำดับ</HeaderCell>
                <Cell>
                  {(rowData, index) => {
                    if (rowData.isTotal) {
                      return ''
                    }
                    return index + 1
                  }}
                </Cell>
              </Column>

              <Column width={120} align="center">
                <HeaderCell>ปีภาษี</HeaderCell>
                <Cell dataKey="withholdingYear" />
              </Column>
              <Column width={180} align="left">
                <HeaderCell>เลขที่ผู้เสียภาษี</HeaderCell>
                <Cell dataKey="taxId" />
              </Column>
              <Column width={200} align="left">
                <HeaderCell>ชื่อผู้มีเงินได้</HeaderCell>
                <Cell dataKey="fullName" />
              </Column>
              <Column width={250} align="left">
                <HeaderCell>ที่อยู่ของผู้มีเงินได้</HeaderCell>
                {/* <Cell dataKey="address" /> */}
                <Cell>
                  {(rowData) => {
                    if (rowData.isTotal) {
                      return <b>{'รวม'}</b>
                    }
                    return rowData.address || ''
                  }}
                </Cell>
              </Column>
              <Column width={160} align="right">
                <HeaderCell>จำนวนเงินได้ที่จ่ายทั้งปี</HeaderCell>
                {/* <Cell dataKey="payAmount" /> */}
                <Cell style={{ textAlign: 'right' }}>
                  {(rowData) => {
                    if (rowData.isTotal) {
                      return <b>{budgetFormat(rowData.payAmount || 0)}</b>
                    }
                    return budgetFormat(rowData.payAmount || 0)
                  }}
                </Cell>
              </Column>
              <Column width={160} align="right">
                <HeaderCell>จำนวนเงินภาษีที่หักและนำส่งทั้งปี</HeaderCell>
                {/* <Cell dataKey="taxAmount" /> */}
                <Cell style={{ textAlign: 'right' }}>
                  {(rowData) => {
                    if (rowData.isTotal) {
                      return <b>{budgetFormat(rowData.taxAmount || 0)}</b>
                    }
                    return budgetFormat(rowData.taxAmount || 0)
                  }}
                </Cell>
              </Column>
              <Column width={180}>
                <HeaderCell>เงื่อนไข</HeaderCell>
                <Cell dataKey="incomeType" />
              </Column>
            </Table>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button
            onClick={() => {
              setFilteredItemsStausModel(false)
            }}
            appearance="subtle"
          >
            ปิด
          </Button>
        </Modal.Footer>
      </Modal>

      {/* old */}
      <Modal
        full
        // show={filteredItemsStausModel}
        show={false}
        // overflow={true}
        onHide={() => {
          setFilteredItemsStausModel(false)
        }}
      >
        <Modal.Header>
          <Modal.Title></Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div style={{ height: 800 }}>
            <Table
              wordWrap
              height={600}
              // minHeight={400}
              // autoHeight
              data={filteredItemsList || []}
              style={{ marginTop: 10 }}
              headerHeight={70}
              width={5050}
              shouldUpdateScroll={false}
            >
              <Column width={70} align="center">
                <HeaderCell>ลำดับ</HeaderCell>
                <Cell>
                  {(rowData, index) => {
                    if (rowData.isTotal) {
                      return ''
                    }
                    return index + 1
                  }}
                </Cell>
              </Column>

              <Column width={170} align="left">
                <HeaderCell>ปี พ.ศ.(ปีภาษีที่หัก)</HeaderCell>
                <Cell dataKey="withholdingYear" />
              </Column>
              <Column width={160} align="left">
                <HeaderCell>เดือน(ปีภาษีที่หัก)</HeaderCell>
                <Cell dataKey="withholdingMonthLabel" />
              </Column>
              <Column width={160} align="left">
                <HeaderCell>วันเดือนปีจ่าย</HeaderCell>
                <Cell dataKey="datePayment" />
              </Column>
              <Column width={160} align="left">
                <HeaderCell>รหัสโครงการ</HeaderCell>
                <Cell dataKey="projectCode" />
              </Column>
              <Column width={160} align="left">
                <HeaderCell>เลขที่ข้อตกลง</HeaderCell>
                <Cell dataKey="contractNo" />
              </Column>
              <Column width={160} align="left">
                <HeaderCell>ประเภทแบบ</HeaderCell>
                <Cell dataKey="withholdingType" />
              </Column>
              <Column width={180} align="left">
                <HeaderCell>สถานะยื่นแบบ</HeaderCell>
                <Cell dataKey="submitStatus" />
              </Column>
              <Column width={160} align="left">
                <HeaderCell>ที่มาข้อมูล</HeaderCell>
                <Cell dataKey="dataSource" />
              </Column>
              <Column width={160} align="left">
                <HeaderCell>เลขลำดับนำส่ง</HeaderCell>
                <Cell dataKey="runingSequenceNo" />
              </Column>
              <Column width={190} align="left">
                <HeaderCell>เลขประจำตัวผู้เสียภาษี</HeaderCell>
                <Cell>
                  {(rowData) => {
                    if (rowData.isTotal) {
                      return (
                        <p style={{ textAlign: 'center' }}>
                          <b>{maskIdCard(rowData.taxId)}</b>
                        </p>
                      )
                    }
                    return maskIdCard(rowData.taxId)
                  }}
                </Cell>
              </Column>
              <Column width={300} align="left">
                <HeaderCell>ชื่อ</HeaderCell>
                <Cell dataKey="fullName" />
              </Column>

              <Column width={300} align="left">
                <HeaderCell>ที่อยู่</HeaderCell>
                <Cell dataKey="address" />
              </Column>
              <Column width={150} align="left">
                <HeaderCell>สาขา</HeaderCell>
                <Cell dataKey="branch" />
              </Column>
              <Column width={180} align="left">
                <HeaderCell>วันเดือนปีที่จ่าย</HeaderCell>
                <Cell>
                  {(rowData) => {
                    if (rowData.isTotal) {
                      return (
                        <p style={{ textAlign: 'center' }}>
                          <b>{rowData.datePayment}</b>
                        </p>
                      )
                    }
                    return rowData.datePayment
                  }}
                </Cell>
              </Column>

              <Column width={150}>
                <HeaderCell>จำนวนเงินที่จ่าย</HeaderCell>
                <Cell style={{ textAlign: 'right' }}>
                  {(rowData) => {
                    if (rowData.isTotal) {
                      return <b>{budgetFormat(rowData.amountPaid || 0)}</b>
                    }
                    return budgetFormat(rowData.amountPaid || 0)
                  }}
                </Cell>
              </Column>

              <Column width={170}>
                <HeaderCell>จำนวนเงินภาษีที่หัก</HeaderCell>
                <Cell style={{ textAlign: 'right' }}>
                  {(rowData) => {
                    if (rowData.isTotal) {
                      return <b>{budgetFormat(rowData.amountTax || 0)}</b>
                    }
                    return budgetFormat(rowData.amountTax || 0)
                  }}
                </Cell>
              </Column>

              <Column width={150} align="left">
                <HeaderCell>เงื่อนไขการหัก</HeaderCell>
                <Cell dataKey="withholdingConditions" />
              </Column>

              <Column width={150} align="left">
                <HeaderCell>วันเดือนปีที่นำส่ง</HeaderCell>
                <Cell dataKey="datePaymentSubmission" />
              </Column>

              <Column width={150}>
                <HeaderCell>จำนวนเงินที่จ่าย</HeaderCell>
                <Cell style={{ textAlign: 'right' }}>
                  {(rowData) => {
                    if (rowData.isTotal) {
                      return <b>{budgetFormat(rowData.amountPaidSubmission || 0)}</b>
                    }
                    return budgetFormat(rowData.amountPaidSubmission || 0)
                  }}
                </Cell>
              </Column>
              <Column width={160}>
                <HeaderCell>จำนวนเงินภาษีที่หักและนำส่ง</HeaderCell>
                <Cell style={{ textAlign: 'right' }}>
                  {(rowData) => {
                    if (rowData.isTotal) {
                      return <b>{budgetFormat(rowData.amountTaxSubmission || 0)}</b>
                    }
                    return budgetFormat(rowData.amountTaxSubmission || 0)
                  }}
                </Cell>
              </Column>
              <Column width={190} align="left">
                <HeaderCell>ยื่นแบบ (ปกติ/เพิ่มเติม)</HeaderCell>
                <Cell dataKey="filingType" />
              </Column>
              <Column width={170} align="left">
                <HeaderCell>วันเดือนปีที่ชำระเงิน</HeaderCell>
                <Cell dataKey="datePaymentTax" />
              </Column>
              <Column width={160} align="left">
                <HeaderCell>หมายเลขที่อ้างอิงในการยื่นแบบ</HeaderCell>
                <Cell dataKey="referenceNumber" />
              </Column>
              <Column width={150} align="left">
                <HeaderCell>เลขที่ใบเสร็จรับเงิน</HeaderCell>
                <Cell dataKey="receiptNumberSubmission" />
              </Column>
              <Column width={150} align="left">
                <HeaderCell>เงินได้ตามมาตรา</HeaderCell>
                <Cell dataKey="incomeAccording" />
              </Column>
              <Column width={140} align="left">
                <HeaderCell>ประเภทแบบที่ยื่นเพื่อรายงานสรรพากรสิ้นปี</HeaderCell>
                <Cell dataKey="typeSubmitted" />
              </Column>
              <Column width={150} align="left">
                <HeaderCell>วันเดือนปีที่นำส่ง</HeaderCell>
                <Cell dataKey="dateSubmission" />
              </Column>
              <Column width={160} align="left">
                <HeaderCell>เลขที่ใบเสร็จรับเงิน</HeaderCell>
                <Cell dataKey="receiptNumber" />
              </Column>
              <Column width={160} align="left">
                <HeaderCell>วันเดือนปีของใบเสร็จ</HeaderCell>
                <Cell dataKey="dateReceipt" />
              </Column>
            </Table>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button
            onClick={() => {
              setFilteredItemsStausModel(false)
            }}
            appearance="subtle"
          >
            ปิด
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  )
}
